export const ksefCompanyPermissionsConst = {
  view: {
    value: "view_ksefcompany",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu firmy!",
  },
  add: {
    value: "add_ksefcompany",
    errorMsg: "Użytkownik nie ma uprawnień do dodania firmy!",
  },
  update: {
    value: "change_ksefcompany",
    errorMsg: "Użytkownik nie ma uprawnień do edycji firmy!",
  },
  delete: {
    value: "delete_ksefcompany",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania firmy!",
  },
};

export const ksefCertificatePermissionsConst = {
  view: {
    value: "view_ksefcertificate",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu certyfikatu!",
  },
  add: {
    value: "add_ksefcertificate",
    errorMsg: "Użytkownik nie ma uprawnień do dodania certyfikatu!",
  },
  update: {
    value: "change_ksefcertificate",
    errorMsg: "Użytkownik nie ma uprawnień do edycji certyfikatu!",
  },
  delete: {
    value: "delete_ksefcertificate",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania certyfikatu!",
  },
};
